// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"F1-z","subtitle":"G1-z","wrapper":"H1-z","leftArrow":"I1-z","rightArrow":"J1-z"};